import React, { useEffect, useState } from "react";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import AddIssueDynemicForm from "../../../addIssueDynemicFrom";

const AddComplain = ({
  toggleDrawer = () => {},
  isEdit,
  complaindata,
  setComplainData,
  setTotalEstimatedCost,
  vinNoValData
}) => {
  const estimateTime = [
    {
      label: "1:00:00",
      value: "01:00:00",
    },

    {
      label: "2:00:00",
      value: "02:00:00",
    },
    {
      label: "3:00:00",
      value: "03:00:00",
    },
    {
      label: "4:00:00",
      value: "04:00:00",
    },
    {
      label: "5:00:00",
      value: "05:00:00",
    },
    {
      label: "6:00:00",
      value: "06:00:00",
    },
    {
      label: "7:00:00",
      value: "07:00:00",
    },
    {
      label: "8:00:00",
      value: "08:00:00",
    },
    {
      label: "9:00:00",
      value: "09:00:00",
    },
    {
      label: "10:00:00",
      value: "10:00:00",
    },
  ];

  const [formData, setFormData] = useState({});
  const [validationErrors, setValidationErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

  const [ kiloMeterData, setKiloMeterData ] = useState("")

  const [ remainingDaysVal , setRemainingDaysVal  ] = useState(0)

  const navigate = useNavigate()

  const [complaintype, setComplaintype] = useState([]);
  const userType = localStorage.getItem("UserType");
  const businessPartnerId = localStorage.getItem("business_partner_id")
  const authToken = localStorage.getItem("authToken");

  useEffect(() => {
    complainTypeDropdown();
  }, []);

  const complainTypeDropdown = async () => {
    try {
      const response = await axiosInstance.post(
        "/jobcard/getcustomerdetails",
        {
          business_partner_id:businessPartnerId==0?1:businessPartnerId ,
          FilterId: null,
          FilterString: null,
          Type: "Complain",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const data = response.data.data;
      const userTypeOptions = data.map((user) => ({
        value: user.id,
        label: user.name,
      }));
      setComplaintype(userTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };



const handleFormSubmit = async (formData) => {
  const errors = {};
  let isValid = true;

  VehicleInputs.forEach((field) => {
    console.log("field>>", field);
    if (field.required && !formData[field.name]) {
      errors[field.name] = "This field is required";
      isValid = false;
    } else if (field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
      errors[field.name] = field.validation.message;
      isValid = false;
    }
  });

   // Additional validation for service_type and cost
   if (formData.service_type === 1 && (!formData.cost || formData.cost === "0")) {
    Swal.fire({
      title: "Enter Cost!",
      text: "For Paid Service, the cost cannot be empty or zero. Please enter a valid cost.",
      icon: "warning",
      confirmButtonText: "OK",
    });
    return; // Stop further execution
  }

  if (!isValid) {
    setValidationErrors(errors);
    console.log("validationErrors", validationErrors);
    return;
  }

  setIsLoading(true);

  // const selectedComplaintType = complaintype.find(
  //   (option) => option.value === formData.complaintype
  // );
  // if (selectedComplaintType) {
  //   // Replace the ID with the label in formData
  //   formData.complaintype = selectedComplaintType.label;
  // }

  const newComplaint = {
    reqType:formData.reqType,
    reqNum:formData.reqNumber,
    warrantyFrom:formData.warrantyFrom,
    warrantyTo:formData.warrantyTo,
    complainName:formData.claimName,
    remark:formData.remark,
    repairStatus:formData.repairStatus,
    estCost:formData.cost,
    status:0,
    kiloMeter: parseInt(kiloMeterData, 10) || 0,
    service_type:formData.service_type
  };

  const existingComplaintsData =
    JSON.parse(localStorage.getItem("JobCardComplainData")) || [];

  if (existingComplaintsData.length >= 3) {
    Swal.fire({
      title: 'Error!',
      text: 'You can only add up to 3 complaints.',
      icon: 'error',
      confirmButtonText: 'OK',
    });
    setIsLoading(false);
    return;
  }

  const totalEstimatedCost =
    existingComplaintsData.reduce((total, complaint) => {
      return total + parseFloat(complaint.estcost || 0);
    }, 0) + newComplaint.estcost;

  // Display confirmation dialog before proceeding
  const confirmation = await Swal.fire({
    title: 'Are you sure?',
    text: 'Do you want to add this complaint?',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonText: 'Yes',
    cancelButtonText: 'Cancel',
  });

  if (!confirmation.isConfirmed) {
    setIsLoading(false); // Reset loading state
    return;
  }

  const updatedComplaintsData = [...existingComplaintsData, newComplaint];
  localStorage.setItem(
    "JobCardComplainData",
    JSON.stringify(updatedComplaintsData)
  );
  setComplainData(updatedComplaintsData);
  setTotalEstimatedCost(totalEstimatedCost);
  console.log("Total Estimated Cost:", totalEstimatedCost);

  Swal.fire({
    title: 'Success!',
    text: 'Complaint added successfully.',
    icon: 'success',
    confirmButtonText: 'OK',
  }).then(() => {
    toggleDrawer();
    setFormData({});
  });

  setIsLoading(false); // Reset loading state
  console.log("Saved complaints data:", updatedComplaintsData);
};



// const handleClaimSubmit = async (formData) => {
//   const errors = {};
//   let isValid = true;

//   VehicleInputs.forEach((field) => {
//     console.log("field>>", field);
//     if (field.required && !formData[field.name]) {
//       errors[field.name] = "This field is required";
//       isValid = false;
//     } else if (field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
//       errors[field.name] = field.validation.message;
//       isValid = false;
//     }
//   });

//   if (!isValid) {
//     setValidationErrors(errors);
//     console.log("validationErrors", validationErrors);
//     return;
//   }

//   setIsLoading(true);
//       console.log("clicked")

//       const result = await Swal.fire({
//         title: "Confirmation",
//         text: "Do you want to claim this record?",
//         icon: "warning",
//         showCancelButton: true,
//         confirmButtonText: "Yes",
//         cancelButtonText: "No",
//       });
//       try{

//         const payload = {
//           reqType:formData.reqType,
//           reqNum:formData.reqNumber,
//           warrantyFrom:formData.warrantyFrom,
//           warrantyTo:formData.warrantyTo,
//           claimName:formData.claimName,
//           remark:formData.remark,
//           repairStatus:formData.repairStatus,
//           cost:formData.cost,
//           status:0,
//           kiloMeter: parseInt(kiloMeterData, 10) || 0,
//           uploadFile:formData.uploadFile
//         }

//         const response = await axiosInstance.post("/jobcard/create-claim-warranty", payload, {
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${authToken}`,
//           },
//         });

//         // console.log(response, "response")
//         // if(response.status === 200){
//         //   setFormData({})
//         // }

//         if (response.status === 200) {
//           // setFormData({})
//           Swal.fire({
//             title: "Success",
//             text: "Claimed Successfully!",
//             icon: "success",
//             confirmButtonText: "OK",
//           }).then(() => {
//             // navigate("/admin/manage-dealer/department");
//           });
//         }

//       }catch(error){
//         console.log(error, "error")
//       }
//     }

  // const handleFormSubmit = async (formData) => {

  //   const errors = {};
  //   let isValid = true;

  //   VehicleInputs.forEach((field) => {
  //     console.log("field>>",field);
  //     if (field.required && !formData[field.name]) {

  //       errors[field.name] = "This field is required";
  //       isValid = false;
  //     } else if (field.required && field.validation && field.validation.pattern && !field.validation.pattern.test(formData[field.name])) {
  //       errors[field.name] = field.validation.message;
  //       isValid = false;
  //     }
  //   });

  //   if (!isValid) {
  //     setValidationErrors(errors);
  //     console.log("validationErrors",validationErrors);
  //     return;
  //   }

  //   setIsLoading(true);

  //   const selectedComplaintType = complaintype.find(
  //     (option) => option.value === formData.complaintype
  //   );
  //   if (selectedComplaintType) {
  //     // Replace the ID with the label in formData
  //     formData.complaintype = selectedComplaintType.label;
  //   }
  //   const newComplaint = {
  //     business_partner_id: 1,
  //     job_card_id: 1,
  //     complain_id: selectedComplaintType ? selectedComplaintType.value : null,
  //     complain_desc: formData?.complaindesc,
  //     complaintype: selectedComplaintType ? selectedComplaintType.label : "",
  //     estcost: parseFloat(formData.estimatedcost) || 0,
  //     technician_id: null,
  //     remark: null,
  //     issue_status: 0,
  //     esttime: formData.estimatedtime || null,
  //     actual_time: null,
  //     tech_remark: null,
  //     repair_id: null,
  //     status: 1,
  //   };

  //   const existingComplaintsData =
  //     JSON.parse(localStorage.getItem("JobCardComplainData")) || [];
  //   if (existingComplaintsData.length >= 5) {
  //     alert("You can only add up to 5 complaints.");
  //     return;
  //   }
  //   const totalEstimatedCost =
  //     existingComplaintsData.reduce((total, complaint) => {
  //       return total + parseFloat(complaint.estcost || 0);
  //     }, 0) + newComplaint.estcost;

  //   const updatedComplaintsData = [...existingComplaintsData, newComplaint];
  //   localStorage.setItem(
  //     "JobCardComplainData",
  //     JSON.stringify(updatedComplaintsData)
  //   );
  //   setComplainData(updatedComplaintsData);
  //   setTotalEstimatedCost(totalEstimatedCost);
  //   console.log("Total Estimated Cost:", totalEstimatedCost);

  //   toggleDrawer();
  //   setFormData({});

  //   console.log("Saved complaints data:", updatedComplaintsData);
  // };


  const handleClaimSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
  
    VehicleInputs.forEach((field) => {
      console.log("field>>", field);
      if (field.required && !formData[field.name]) {
        errors[field.name] = "This field is required";
        isValid = false;
      } else if (
        field.required &&
        field.validation &&
        field.validation.pattern &&
        !field.validation.pattern.test(formData[field.name])
      ) {
        errors[field.name] = field.validation.message;
        isValid = false;
      }
    });
  
    if (!isValid) {
      setValidationErrors(errors);
      console.log("validationErrors", validationErrors);
      return;
    }
  
    setIsLoading(true);
    console.log("clicked");
  
    const result = await Swal.fire({
      title: "Confirmation",
      text: "Do you want to claim this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });
  
    if (result.isConfirmed) {
      try {
        const formDataPayload = new FormData();
  
        formDataPayload.append("reqType", formData.reqType);
        formDataPayload.append("reqNum", formData.reqNumber);
        formDataPayload.append("warrantyFrom", formData.warrantyFrom);
        formDataPayload.append("warrantyTo", formData.warrantyTo);
        formDataPayload.append("claimName", formData.claimName);
        formDataPayload.append("remark", formData.remark);
        formDataPayload.append("repairStatus", formData.repairStatus);
        formDataPayload.append("cost", formData.cost);
        formDataPayload.append("service_type", formData.service_type);
        formDataPayload.append("status", 0);
        formDataPayload.append("kiloMeter", parseInt(kiloMeterData, 10) || 0);
        
        // Append file
        if (formData.uploadFile) {
          formDataPayload.append("uploadFile", formData.uploadFile);
        }
  
        const response = await axiosInstance.post(
          "/jobcard/create-claim-warranty",
          formDataPayload,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
  
        if (response.status === 200) {
          Swal.fire({
            title: "Success",
            text: "Claimed Successfully!",
            icon: "success",
            confirmButtonText: "OK",
          }).then(() => {
            // navigate("/admin/manage-dealer/department");
          });
        }
      } catch (error) {
        console.log(error, "error");
      } finally {
        setIsLoading(false);
      }
    } else {
      setIsLoading(false);
    }
  };
  

  // const apiCall = async (formData) => {
  //   try{

  //     const payload = {
  //       reqType:formData.reqType,
  //       reqNumber:formData.reqNumber
  //     }

  //     const response = await axiosInstance.post("jobcard/check-warranty", payload, {
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${authToken}`,
  //       },
  //     });

  //     const fetchedData = response?.data?.data[0]
  //     console.log(fetchedData, "fetchedData")
      

  //     const kiloMeterVal = fetchedData.kilometer 
  //     setKiloMeterData(kiloMeterVal)
  //     console.log(kiloMeterVal, "kiloMeterVal")

  //     const remainingDays = fetchedData.remainingDays
  //     setRemainingDaysVal(remainingDays)

  //     setFormData((prevData) => ({
  //       ...prevData,
  //       warrantyFrom:fetchedData.warrantyFrom,
  //       warrantyTo:fetchedData.warrantyTo,
  //       kiloMeter:fetchedData.kilometer,
  //       remainingdays:fetchedData.remainingDays
  //     }));

  //     console.log(response)
  //   }catch(error){
  //     console.log(error, "error")
  //   }
  // }

  const apiCall = async (formData) => {
    try {
      const payload = {
        reqType: formData.reqType,
        reqNumber: formData.reqNumber,
      };
  
      const response = await axiosInstance.post("jobcard/check-warranty", payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });
  
      const fetchedData = response?.data?.data[0];
      console.log(fetchedData, "fetchedData");
  
      const kiloMeterVal = fetchedData.kilometer;
      setKiloMeterData(kiloMeterVal);
      console.log(kiloMeterVal, "kiloMeterVal");
  
      const remainingDays = fetchedData.remainingDays;
      setRemainingDaysVal(remainingDays);
  
      setFormData((prevData) => ({
        ...prevData,
        warrantyFrom: fetchedData.warrantyFrom,
        warrantyTo: fetchedData.warrantyTo,
        kiloMeter: fetchedData.kilometer,
        remainingdays: remainingDays < 0 ? "0.00" : remainingDays, // Set to 0 if negative
      }));
  
      console.log(response);
    } catch (error) {
      console.log(error, "error");
    }
  };
  


  useEffect(() => {
    setFormData({
      reqType: "V"
    })
  },[])

  const handleNavigate = () => {
    navigate("/manage-sales/productlist/generate-order")
  }

  useEffect(() => {
    setFormData((pre) => ({
      ...pre,
      reqNumber:vinNoValData,
      // kiloMeter: kiloMeterData
    }));
  },[])

  const VehicleInputs = [

    {
      name: "reqType",
      placeholder:"Enter ",
      type: "radio",
      options:[ {value:"V", label:"Vin No."}],
      required: true,
      gridClass: "col-lg-10",
      
    },
    {
      name: "reqNumber",
      label: formData.reqType === "V" ? "Enter Vin No." : "Enter Spare Parts/ Accessory No." ,
      type: "servicetext",
      required: true,
      placeholder: "Enter",
      isComplaint: true,
      // options: complaintype,

      gridClass: "col-lg-10",
    },
    ...(kiloMeterData === null || kiloMeterData === ""
      ? [
          {
            name: "warrantyFrom",
            label: "Warranty From",
            placeholder: "Trans. Date",
            type: "date",
            gridClass: "col-lg-10",
            disabled: true,
          },
          {
            name: "warrantyTo",
            label: "Warranty To",
            placeholder: "Trans. Date",
            type: "date",
            gridClass: "col-lg-10",
            disabled: true,
          },
        ]
      : [
          {
            name: "kiloMeter",
            label: "Kilometer",
            type: "text",
            placeholder: "Kilometer",
            validation: { required: true },
            required: true,
            gridClass: "col-lg-10",
          },
        ]),
        {
          name: "remainingdays",
          label: "Remaining Days",
          type: "text",
          placeholder: "Days",
          disabled:"true",
          // validation: { required: true },
          // required: true,
          gridClass: "col-lg-10",
        },
    {
      name: "claimName",
      label: "Complain Name",
      type: "text",
      placeholder: "Enter Description",
      validation: { required: true },
      required: true,
      gridClass: "col-lg-10",
    }, 
    {
      name: "remark",
      label: "Remark",
      type: "text",
      placeholder: "Enter Description",
      validation: { required: true },
      required: true,
      gridClass: "col-lg-10",
    },     
    {
      name: "repairStatus",
      label: "Repair Status",
      type: "dropdown",
      required: true,
      placeholder: "Select Complaint",

      options: [
        { label: "Repairable", value: "repairable" },
        { label: "Nonrepairable", value: "nonrepairable" },,
      ],

      gridClass: "col-lg-10",
    },
    {
      name: "service_type",
      label: "Service Type",
      type: "dropdown",
      // required: true,
      placeholder: "Select Service",

      options: [
        { label: "Paid Service", value: 1 },
        { label: "Free Service", value: 0 },
      ],

      gridClass: "col-lg-10",
    },
    {
      name: "cost",
      label: "Estimated Cost",
      type: "number",
      placeholder: "Enter Cost",
      validation: { 
      required: true,

      pattern: /^\d+(\.\d{1,2})?$/, // Allows up to 2 decimal places
      message:  "Only digits and up to 2 decimal places are allowed",
      },
      required: true,
      gridClass: "col-lg-10",
    },
    {
      name: "uploadFile",
      label: "Item Screenshot",
      type: "file",
      required: true,
      gridClass: "col-lg-6",
      validation: { required: true },
    },
    {
      name: "status",
      label: "Status",
      type: "dropdown",
      required: true,
      placeholder: "Select Complaint",

      options: [
        { label: "Pending", value: "0" },
        { label: "Done", value: "1" },,
      ],

      gridClass: "col-lg-10",
    },
  ];

  useEffect(() => {
    setFormData((prevData) => ({
      ...prevData,
      status: "0",
      // cost: "0"
      
    }))
  },[])

  useEffect(() => {

    if (formData.service_type === 0) {
      setFormData((prevData) => ({
        ...prevData,
        cost: "0.00",
      }));
    } else if (formData.service_type === 1){
      setFormData((prevData) => ({
        ...prevData,
        cost: "",
      }));
    }
  },[formData.service_type])

  return (
    <div>
      <DynamicForm
        formConfig={VehicleInputs}
        formData={formData}
        setFormData={setFormData}
        onSubmit={handleFormSubmit}
        validationErrors={validationErrors}
        setValidationErrors={setValidationErrors}
        apiCall={apiCall}
      />

{/* { remainingDaysVal === 0 ? "Claim Warranty": "Generate PO" } */}

{
  remainingDaysVal === 0 ? (

    <button
        onClick={() => navigate("/manage-sales/productlist/generate-order")}
        className="clear-btn"
        style={{ marginTop: "15px", width: "85%" }}
      >
        Generate PO
       
      </button>


  ) : (
    <button
        onClick={() => {
          // handleFormSubmit(formData);
          handleClaimSubmit(formData)
        }}
        className="clear-btn"
        style={{ marginTop: "15px", width: "85%" }}
      >
        Claim Warranty
       
      </button>
  )
}

      <button
        onClick={() => {
          handleFormSubmit(formData);
        }}
        className="submit-btn"
        style={{ marginTop: "15px", width: "85%" }}
      >
        Save
      </button>
    </div>
  );
};

export default AddComplain;
